import { ExternalLink, Rocket } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { NEXT_STEPS } from "@/lib/resources";
import { track } from "@/lib/track";

export function NextSteps() {
  return (
    <section>
      <div className="mb-4 flex items-center gap-2">
        <Rocket className="h-6 w-6 text-primary" />
        <h2 className="text-2xl font-bold">Start using BCH for real</h2>
      </div>
      <p className="mb-4 text-muted-foreground">
        The lessons are simulated — but Bitcoin Cash is real. When you're ready,
        take your skills out into the world.
      </p>
      <div className="grid gap-4 sm:grid-cols-3">
        {NEXT_STEPS.map((step) => {
          const isWallet = step.title.toLowerCase().includes("wallet");
          return (
          <Card
            key={step.title}
            className="flex flex-col border-2 transition-all hover:-translate-y-1 hover:shadow-lg"
          >
            <CardContent className="flex flex-1 flex-col gap-3 p-5">
              <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-green-500 to-emerald-600 text-2xl shadow-sm">
                {step.emoji}
              </span>
              <div className="flex-1">
                <h3 className="text-lg font-bold leading-tight">
                  {step.title}
                </h3>
                <p className="mt-1 text-sm text-muted-foreground">
                  {step.description}
                </p>
              </div>
              <div className="mt-1 space-y-2">
                {step.links.map((link) => (
                  <Button
                    key={link.href}
                    asChild
                    variant="outline"
                    className="h-auto w-full justify-between py-2.5"
                  >
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={() => {
                        if (isWallet) track("wallet_click");
                      }}
                    >
                      <span className="flex flex-col items-start leading-tight">
                        <span className="font-semibold">{link.label}</span>
                        {link.hint && (
                          <span className="text-xs font-normal text-muted-foreground">
                            {link.hint}
                          </span>
                        )}
                      </span>
                      <ExternalLink className="h-4 w-4 shrink-0 opacity-70" />
                    </a>
                  </Button>
                ))}
              </div>
            </CardContent>
          </Card>
          );
        })}
      </div>
    </section>
  );
}
